import React from "react";
import { connect } from "react-redux";

import {
  doGetAllContacts,
  doCreateContact,
  doUpdateContact,
  doDeleteContact,
  doUploadContacts,
  doDeleteContacts,
} from "../stores/thunk";
import { selectAllContacts } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.contact.isFetching,
      action: state.contact.action,
      message: state.contact.message,
      status: state.contact.status,
      metadata: state.contact.metadata,
      contacts: selectAllContacts(state),
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps, {
    doGetAllContacts,
    doCreateContact,
    doUpdateContact,
    doDeleteContact,
    doUploadContacts,
    doDeleteContacts,
  })(Container);
};
